import React from 'react';
import {Avatar} from '@mui/material';
import {getKBImage} from "../KB/KBImage.js";
import {fromWebBot} from "../App/utils.js";
import {kbBackgroundOpacity} from "../App/theme";

export const ChatAvatarBackground = ({kbId}) => {
    return (
        <div className="chat-background-image">
            <Avatar
                style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    backgroundImage: `url(${getKBImage(kbId)})`,
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                    backgroundSize: 'contain',
                    opacity: fromWebBot ? 0.12 : kbBackgroundOpacity,
                    zIndex: 0,
                    pointerEvents: 'none',
                    borderRadius: '0%'
                }}
                alt="AI" src={getKBImage(kbId)}
            />
        </div>
    )
}